import { alpha, Box, Container, Stack, useTheme } from "@mui/material";
import FactsSection from "../../../component/courseDetailSection/FactsSection";
import HeroSection from "../../../component/courseDetailSection/HeroSection";
import { useCourseDetailsPageData } from "../../../hook/useCourseDetailsPageData";
import type { CoursePageMap } from "../../../type/course";
import { courseName, partTimeFacts, partTimeRequirements } from "./const/course";
import CourseTimeline_PartTime from "./component/CourseTimeline_PartTime";
import SectionShell from "../../../component/courseDetailSection/SectionShell";

export default function CourseDetailsPage_PartTime() {
  const theme = useTheme();
  const pageMap: CoursePageMap = {
    status: {
      state: "ended",
      label: "已結束",
      notice: "此課程已結束，你仍可瀏覽課程綱要與過往屆別。",
    },
    header: {
      title: courseName,
      primaryCta: {
        label: "瀏覽課程資料",
        action: { target: "/courseDetails/partTime" },
      },
    },
    sections: [
      {
        id: "description",
        title: "課程簡介",
        content: {
          paragraphs: ["晚間及星期日上課，配合工作或學習安排完成全端開發訓練。"],
        },
      },
      { id: "cohorts", title: "過往屆別", content: { cohorts: [] } },
      { id: "sharing", title: "學員分享", content: { items: [] } },
      {
        id: "facts",
        title: "課程資料",
        content: {
          facts: partTimeFacts,
          requirements: {
            title: partTimeRequirements.title,
            statusTag: "已結束",
            items: partTimeRequirements.items,
          },
        },
      },
    ],
  };
  const data = useCourseDetailsPageData({ courseName, pageMap });

  return (
    <Box
      sx={{
        minHeight: 1,
        bgcolor: "background.default",
        backgroundImage: `
          radial-gradient(ellipse 58% 22% at 22% 5%, ${alpha(theme.palette.info.main, 0.1)} 0%, ${alpha(theme.palette.info.main, 0)} 76%),
          radial-gradient(ellipse 50% 18% at 12% 47%, ${alpha(theme.palette.info.dark, 0.09)} 0%, ${alpha(theme.palette.info.dark, 0)} 74%),
          radial-gradient(ellipse 56% 24% at 92% 93%, ${alpha(theme.palette.info.light, 0.16)} 0%, ${alpha(theme.palette.info.main, 0.06)} 42%, ${alpha(theme.palette.info.main, 0)} 76%),
          linear-gradient(180deg, ${alpha(theme.palette.primary.main, 0.72)} 0%, ${theme.palette.background.default} 18%, ${
          theme.palette.background.default
        } 74%, ${
          theme.palette.background.default
        } 100%)
        `,
        backgroundSize: "100% 100%, 100% 100%, 100% 100%, 100% 100%",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Container maxWidth="lg" sx={{ px: { xs: 3, md: 4 } }}>
        <Stack spacing={0}>
          <HeroSection data={data} />
          <SectionShell title="課程模組">
            <CourseTimeline_PartTime />
          </SectionShell>
          <FactsSection data={data} />
        </Stack>
      </Container>
    </Box>
  );
}
